import axios from "axios";
import { encryptAES, decryptAES } from "./cryptoUtils";
const apiBase = process.env.REACT_APP_API_BASE_URL || "/api";
const apiClient = axios.create({
 baseURL: apiBase,
 withCredentials: true,
});
// REQUEST
apiClient.interceptors.request.use(
 async (config) => {
   try {
     const sessionToken = localStorage.getItem("session_token");
     if (sessionToken) {
       config.headers["Authorization"] = `Bearer ${sessionToken}`;
     }
   } catch (err) {
     console.error("Error fetching session token:", err);
   }
   if (config.method === "post" && config.data) {
     const plainDataString = JSON.stringify(config.data);
     const encryptedPayload = encryptAES(plainDataString);
     config.data = { encryptedRequest: encryptedPayload };
   }
   config.headers["Content-Type"] = "application/json";
   return config;
 },
 (error) => Promise.reject(error)
);
// RESPONSE
apiClient.interceptors.response.use(
 (response) => {
   if (response.data && response.data.encryptedResponse) {
     try {
       const decryptedString = decryptAES(response.data.encryptedResponse);
       response.data = JSON.parse(decryptedString);
     } catch { /* noop */ }
   }
   return response;
 },
 (error) => {
   const message = error.response?.data?.detail;
   if (error.response?.status === 401 && message === "Session invalid or logged in from another device.") {
     alert("You were logged out because you logged in from another device.");
     localStorage.removeItem("session_token");
     localStorage.removeItem("ntid");
     window.location.href = "/";
     return;
   }
   return Promise.reject(error);
 }
);
export default apiClient;